module.exports = __webpack_public_path__ + "static/media/vpj-logo-dark.2928f5ab.png";